import {ApiRequestEnum} from 'src/app/core/enums/api-request.enum';
import {ApiService} from 'src/app/core/services/api.service';
import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {ICurrentAddress} from "../../core/services/location.service";

@Injectable({
	providedIn: 'root',
})
export class StoreService {
	private searchCriteria: BehaviorSubject<any>;

	constructor(
		private apiService: ApiService,
	) {
		this.searchCriteria = new BehaviorSubject({});
	}

	GetStoreById(storeId: string) {
		return this.apiService.get(ApiRequestEnum.STORE_BY_ID.replace('{{name}}', storeId));
	}

	GetStores(param: any) {
		return this.apiService.post(ApiRequestEnum.STORES, param);
	}

	GetTopStores() {
		return this.apiService.get(ApiRequestEnum.STORES_TOP);
	}

	public emitSearchCriteria(searchCriteria) {
		this.searchCriteria.next(searchCriteria);
	}

	public subscribeToSearchCriteria() {
		return this.searchCriteria.asObservable();
	}
}
